import { jsxs, jsx } from "react/jsx-runtime";
import AntSwitch from "antd/es/switch";
import classnames from "../../utils/classnames.js";
import Typography from "../Typography/Typography.js";
import './Switch.css';/* empty css            */
const Switch = ({
  className,
  classNameWrapper,
  classNameLabel,
  label,
  width,
  height,
  ...props
}) => {
  return /* @__PURE__ */ jsxs("div", { className: classnames("perxis-auto-switch-wrapper", classNameWrapper), children: [
    /* @__PURE__ */ jsx(
      AntSwitch,
      {
        className: classnames("perxis-auto-switch", className),
        style: {
          "--perxis-auto-switch-width": width ? `${width}px` : null,
          "--perxis-auto-switch-height": height ? `${height}px` : null
        },
        ...props
      }
    ),
    !!label && /* @__PURE__ */ jsx(Typography.Paragraph, { color: "darkest", level: "main", className: classnames("perxis-auto-switch-label", classNameLabel), children: label })
  ] });
};
export {
  Switch as default
};
//# sourceMappingURL=Switch.js.map
